<template>
  <div class="place-autocomplete">
    <div class="place-autocomplete__inner">
      <text-input
        :value="value"
        :button="buttonText"
        placeholder="Wpisz lub znajdź miejsce"
        center-placeholder
        xs-hide-button
        big
        @input="handleInput"
        @click="$emit('add')"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
      />
      <place-autocomplete-list
        :predictions="predictions"
        :visible="isListVisible"
        @click="pickPrediction"
      />

      <transition name="fade-up">
        <span v-if="isInvalid" class="place-autocomplete__error">
          Podany adres nie istnieje w Warszawie
        </span>
      </transition>
    </div>

    <transition name="fade-up">
      <div v-if="buttonText" class="place-autocomplete__btn">
        <button-component
          @click="$emit('add')"
          fixed-width
        >
          Dodaj
        </button-component>
      </div>
    </transition>
  </div>
</template>

<script>
import PlaceAutocompleteList from '@/components/PlaceAutocomplete/PlaceAutocompleteList'
import TextInput from '@/components/TextInput'
import ButtonComponent from '@/components/Button'

export default {
  components: {
    PlaceAutocompleteList,
    TextInput,
    ButtonComponent
  },
  props: {
    predictions: {
      type: Array,
      default: () => []
    },
    isListVisible: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonText () {
      return this.value && 'Dodaj'
    }
  },
  methods: {
    pickPrediction (prediction) {
      this.$emit('pick', prediction)
    },
    handleInput (input) {
      this.$emit('input', input)
    }
  }
}
</script>

<style lang="scss" scoped>
  .place-autocomplete {
    &__btn {
      @include hide-up(md);

      position: fixed;
      bottom: 30px;
      left: 0;
      width: 100%;
      z-index: z(submit-map) + 1;
      pointer-events: auto;
      display: flex;
      justify-content: center;
    }

    &__error {
      @include font($akrobat-font, 900);
      display: block;
      padding-top: .5em;
      font-size: 14px;
      text-align: center;
      text-transform: uppercase;
      letter-spacing: .38em;
      line-height: 2;
      max-width: 100%;
    }

    &__inner {
      position: fixed;
      top: 35px;
      left: 50%;
      transform: translateX(-50%);

      padding: 0 2 * $container-margin;
      width: 100%;
      max-width: 540px;

      z-index: z(submit-map);
      pointer-events: auto;

      @include media-up(lg) {
        top: 40px;
      }

      @include media-up(xl) {
        top: 52px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceAutocomplete/PlaceAutocomplete.vue